var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownOutZd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1731912159480,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4259,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M513.4 599.7c-8.8 0-17.5-3.3-24.2-10L371.5 472c-9.8-9.7-9.8-25.6 0-35.3 9.8-9.8 25.6-9.8 35.3 0l106.6 106.6L620 436.7c9.8-9.8 25.6-9.8 35.3 0 9.8 9.8 9.8 25.6 0 35.3L537.6 589.7c-6.7 6.7-15.4 10-24.2 10z",
    fill: "#666",
    "p-id": 4260
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownOutZd);
export default __webpack_public_path__ + "static/media/down-out-zd.5940a52b.svg";
export { ForwardRef as ReactComponent };